<template>
<div>  <div :class="[ 'g-cursor', { 'g-cursor_hover': hover }, {'g-cursor_hide': hideCursor} ]">
  <div :style="cursorCircle" class="g-cursor__circle"></div>
  <div class="g-cursor__point" ref="point" :style="cursorPoint"></div>
</div >
   <div class="main" id="home">
    <Navbar />
    <TheCanvas />
    <Sidebar />
  </div>
  <!-- <div class="main" id="education">dsds</div> -->
  <div class="main" id="work"><Work /></div>
  <div class="main" id="projects"><Projects /></div>
  <div class="main" id="technologies"><Techonlogies/></div>
  <div class="main" id="bye">
    <Contact />
  </div>
</div>
</template>

<script>
import { ref } from "vue";
import HelloWorld from "./components/HelloWorld.vue";
import Navbar from "./components/Navbar.vue";
import TheCanvas from './components/TheCanvas';
import Sidebar from "./components/Sidebars.vue";
import Techonlogies from "./views/Techonlogies.vue";
import Projects from "./views/Projects.vue";
import Work from "./views/Work.vue";
import Contact from "./views/Contact.vue";

export default {
  name: "LayoutDefault",

  components: {
    HelloWorld,
    Navbar,
    TheCanvas,
    Sidebar,
    Techonlogies,
    Projects,
    Work,
    Contact
},
  mounted() {
    document.addEventListener("mousemove", this.moveCursor);
    document.addEventListener('mouseleave', e => {
      this.hideCursor = true;
    });
    document.addEventListener('mouseenter', e => {
      this.hideCursor = false;
    });
    
  },
  computed: {
    cursorCircle() {
      return `transform: translateX(${this.xParent}px) translateY(${this.yParent}px) translateZ(0) translate3d(0, 0, 0);`
    },
    cursorPoint() {
      return `transform: translateX(${this.xChild - 3}px) translateY(${this.yChild - 3}px) translateZ(0) translate3d(0, 0, 0);`
    }
  },
  methods: {
    moveCursor(e) {
      if (screen.width > 821){
      this.xChild = e.clientX;
      this.yChild = e.clientY;
      setTimeout(() => {
        this.xParent = e.clientX - 13.5;
        this.yParent = e.clientY - 13.5;
      }, 100);
    }
    }
  },
  data() {
    return {
      xChild: 0,
      yChild: 0,
      xParent: 0,
      yParent: 0,
      hover: false,
      hideCursor: true
    };
  },
};
</script>

<style lang="scss">
.main {
  cursor: none;
  height: auto;
  &:last-child{
    height: 70vh;
  }
  &__title {
    position: absolute;
    top: -25px;
    left: 10vw;
    font-weight: bold;
    -webkit-text-stroke: 1px rgba(68, 68, 68, 0.774);
    /* width and color */

    font-family: sans;
    color: rgb(34, 33, 33);
  }

  &__page {
    width: 80vw;
    height: 80vh;
    border-radius: 52px;
    background: #333333;
    box-shadow: 37px 37px 76px #2c2c2c,
      -37px -37px 76px #3a3a3a;
    display: flex;
    align-items: center;
    justify-content: center;
    &__text {
      padding: 5vw;
      font-size: 4rem;
      font-family: monospace;
    font-weight: 900;
    -webkit-text-stroke: 0.3px rgb(73, 73, 73); /* width and color */
      color: #353434;
text-shadow: 2px -2px 6px #020202,
-2px 2px 6px #646464; 
    }
    
  }
}

.row {
  width: 100%;
  height: 90%;
}


html {
  scroll-behavior: smooth;
}
body, html {
    width: 100%;
    height: 100%;
    background: #000;
    margin: 0;
    cursor: none;
  }
  @media screen and (min-width: 821px) {
    .g-cursor {
position: absolute;
&_hide {
  opacity: 0;
  width: 60px;
  height: 60px;
  transition: width .6s ease,
    height .6s ease,
    opacity .6s ease;
}

&__circle {
  pointer-events: none;
  user-select: none;
  top: 0;position: absolute;
  left: 0;
  position: fixed;
  width: 30px;
  height: 30px;
  border: 2px solid #fff;
  mix-blend-mode: difference;
  border-radius: 100%;
  z-index: 5555;
  backface-visibility: hidden;
  transition: opacity .6s ease;
}

&__point {
  top: 0;
  left: 0;position: absolute;
  position: fixed;
  width: 10px;
  height: 10px;
  pointer-events: none;
  user-select: none;
  border-radius: 100%;
  background: white;
  mix-blend-mode: difference;
  z-index: 55555555;
  backface-visibility: hidden;
  will-change: transform;
}

&_hover {
  .g-cursor__circle {
    opacity: 0;position: absolute;
    width: 60px;
    height: 60px;
    transition: width .6s ease,
      height .6s ease,
      opacity .6s ease;
  }
}
}
}
/** Scroll Bar */
/* width */
::-webkit-scrollbar {
  width: 0px;
}
/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}
/* Handle */
::-webkit-scrollbar-thumb {
  background: #888;
}
/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}
</style>